var ibanFieldValidator = require('lib/util/formValidators.ts').ibanFieldValidator;
var urlBlacklistValidation = require('lib/util/formValidators.ts').urlBlacklistValidation;
(function (w, $, SCS) {

	/* Dependencies:
	 * ScForm.ValidationReturn.js
	 */

	'use strict';

	/**
	 * The class ClientValidation is a helper for form clientside validation and takes the validation object as a parameter.
	 *
	 * ex. 1 {
	 *		"required":true,
	 *		"minLength":0,
	 *		"constraintMessage":"Bitte geben Sie einen korrekten Wert als Name ein",
	 *		"maxLength":0,
	 *		"requiredMessage":"Bitte füllen Sie das Feld Name aus",
	 *		"lengthMessage":null,
	 *		"hasLengthValidation":false,
	 *		"hasConstraint":false,
	 *		"constraintRegex":"^[\\w\\.,\\s\\u0080-\\u00ff\\u008C\\u0153\\-\\/]+$",
	 *		'constraintType':null
	 * }
	 * ex. 2 {
	 *		'required':true,
	 *		'requiredMessage':'field is required',
	 *		'minLength':4,
	 *		'maxLength':10,
	 *		'lengthMessage':'length must be between x and y',
	 *		'constraintMessage':'email is not valid',
	 *		'hasConstraint':true,
	 *		'hasLengthValidation':false,
	 *		'lengthRegex':null,
	 *		'constraintRegex':'xyz',
	 *		'constraintType':'REGEX'
	 * }
	 *
	 * @author Thomas Junghans
	 * @namespace ScForm
	 * @class ClientValidation
	 * @param {Object} clientValidationJson
	 * @constructor
	 */

	function ClientValidation(clientValidationJson, $form) {
		this.init(clientValidationJson, $form);
	}

	ClientValidation.prototype = {
		constructor: ClientValidation,

		isUndef: function (value) {
			return typeof(value) === 'undefined';
		},

		init: function (clientValidationJson, $form) {

			// Alias
			var cvj = clientValidationJson;

			/**
			 * @property required
			 * @type {boolean}
			 */
			this.required = this.isUndef(cvj.required) ? false : cvj.required;

			/**
			 * @property requiredMessage
			 * @type {string}
			 */
			this.requiredMessage = this.isUndef(cvj.requiredMessage) ? '' : cvj.requiredMessage;

			/**
			 * @property minLength
			 * @type {Number}
			 */
			this.minLength = this.isUndef(cvj.minLength) ? 0 : cvj.minLength;

			/**
			 * A number between 0 cvj.maxLength or 255
			 * @property maxLength
			 * @type {Number}
			 */
			this.maxLength = this.isUndef(cvj.maxLength) || cvj.maxLength === 0 ? 255 : cvj.maxLength;

			/**
			 * @property lengthMessage
			 * @type {string}
			 */
			this.lengthMessage = this.isUndef(cvj.lengthMessage) ? '' : cvj.lengthMessage;

			/**
			 * @property constraintMessage
			 * @type {string}
			 */
			this.constraintMessage = this.isUndef(cvj.constraintMessage) ? '' : cvj.constraintMessage;

			/**
			 * @property constraintType
			 * @type {string}
			 */
			this.constraintType = this.isUndef(cvj.constraintType) ? '' : cvj.constraintType;

			/**
			 * @property hasLengthValidation
			 * @type {boolean}
			 */
			this.hasLengthValidation = this.isUndef(cvj.hasLengthValidation) ? false : cvj.hasLengthValidation;

			/**
			 * @property hasConstraint
			 * @type {boolean}
			 */
			this.hasConstraint = this.isUndef(cvj.hasConstraint) ? false : cvj.hasConstraint;

			/**
			 * @property constraintRegex
			 * @type {null|RegExp}
			 */
			this.constraintRegex = this.isUndef(cvj.constraintRegex) ? null : new RegExp(cvj.constraintRegex);

			/**
			 * @property constraintData
			 * @type {null|obj}
			 */
			this.constraintData = this.isUndef(cvj.constraintData) ? null : cvj.constraintData;

			/**
			 * @property foreignValidationModels
			 * @type {null|obj}
			 */
			this.foreignValidationModels = this.isUndef(cvj.foreignValidationModels) ? null : cvj.foreignValidationModels;

			/**
			 * @property lengthRegex
			 * @type {null|RegExp}
			 */
			this.lengthRegex = this.isUndef(cvj.lengthRegex) ? null : new RegExp(cvj.lengthRegex);

			/**
			 * @property $form The form element used
			 * @type {jQuery|null}
			 */
			this.$form = $form;

			/**
			 * @property formAPI The form module API (if any)
			 * @type {Object}
			 */
			this.formAPI = null;
			if (this.$form) {
				this.formAPI = this.$form.data('form-api');
			}
		},

		/**
		 * @method getConstraintMessage
		 * @returns {string}
		 */
		getConstraintMessage: function () {
			return this.constraintMessage;
		},

		/**
		 * @method getRequiredMessage
		 * @returns {string}
		 */
		getRequiredMessage: function () {
			return this.requiredMessage;
		},

		/**
		 * @method getLengthMessage
		 * @returns {string}
		 */
		getLengthMessage: function () {
			return this.lengthMessage;
		},

		/**
		 * @method isRequired
		 * @returns {boolean}
		 */
		isRequired: function () {
			return this.required;
		},

		hasCorrectLength: function (value) {
			if (this.hasLengthValidation === false) {
				return true;
			}

			// Replace all carriage returns with a space, otherwise the regex will fail
			value = value.replace(/\n/g, ' ');

			return this.lengthRegex instanceof RegExp && this.lengthRegex.test(value) === true;
		},

		/**
		 * Expects either the number of checked checkboxes (0...n) or true for checked, false for not checked
		 *
		 * @method validateCheckboxGroup
		 * @param {boolean|number} selected
		 * @returns {ValidationReturn}
		 */
		validateCheckboxGroup: function (selected) {
			var cv = this,
				vr = w.ScForm.createValidationReturn(true, '');

			if (cv.isRequired() === false) {
				return vr;
			} else if (selected === false || selected === 0) {
				vr.set(false, cv.getRequiredMessage());
				return vr;
			}

			return vr;
		},

		/**
		 * Expects either the number of checked radios (0 or not 0) or true for checked, false for not checked
		 * selected must be either true or exactly 1 to validate (only 1 radio can be selected in a group)
		 *
		 * @method validateRadioGroup
		 * @param {boolean|number} selected
		 * @returns {ValidationReturn}
		 */
		validateRadioGroup: function (selected) {
			var cv = this,
				vr = w.ScForm.createValidationReturn(true, '');

			if (cv.isRequired() === false) {
				return vr;
			} else if (selected === false || selected < 1 || selected > 1) {
				vr.set(false, cv.getRequiredMessage());
				return vr;
			}

			return vr;
		},

		validateSDXInputGroup: function (values) {
			var cv = this,
				vr = w.ScForm.createValidationReturn(true, '');

			if (cv.isRequired() === false) {
				return vr;
			} else if (!values || !values.length) {
				vr.set(false, cv.getRequiredMessage());
				return vr;
			}

			return vr;
		},

		/**
		 *
		 * @param value
		 * @returns {ValidationReturn}
		 */
		validate: function (value, context) {
			var cv = this,
				vr = w.ScForm.createValidationReturn(true, '');

			if (cv.constraintType === 'FOREIGN_FIELD') {
				return cv.validateByForeignField(value);
			}

			// 1. Required
			if (cv.isRequired() && value === '') {
				vr.set(false, cv.getRequiredMessage());
				return vr;
			}

			// 2. Check length
			if (value !== '' && cv.hasLengthValidation === true && cv.hasCorrectLength(value) === false) {
				vr.set(false, cv.getLengthMessage());
				return vr;
			}

			// 3. Check constraint
			if (cv.hasConstraint === false || value === '') {
				return vr;
			} else if (cv.constraintType === 'REGEX' && cv.constraintRegex instanceof RegExp && cv.constraintRegex.test(value) === false) {
				vr.set(false, cv.getConstraintMessage());
			} else if (cv.constraintType === 'DATE' && cv.validateDate(value) === false) {
				vr.set(false, cv.getConstraintMessage());
			} else if (cv.constraintType === 'DATE_IN_FUTURE' && cv.validateDate(value, true) === false) {
				vr.set(false, cv.getConstraintMessage());
			} else if (cv.constraintType === 'DATE_IN_PAST' && cv.validateDate(value, false) === false) {
				vr.set(false, cv.getConstraintMessage());
			} else if (cv.constraintType === 'URL_EXISTS' && cv.validateUrlExists(value, cv.constraintData, context) === false) {
				vr.set(false, cv.getConstraintMessage());
			} else if (cv.constraintType === 'SIM_NUMBER' && cv.validateSimCardNumber(value, cv.constraintData, context) === false) {
				vr.set(false, cv.getConstraintMessage());
			} else if (cv.constraintType === 'AJAX' && cv.validateByAjax(value, cv.constraintData, context) === false) {
				vr.set(false, cv.getConstraintMessage());
			} else if (cv.constraintType === 'IBAN' && cv.validateIBAN(value, context) === false) {
				vr.set(false, cv.getConstraintMessage());
			} else if (cv.constraintType === 'URL_NOT_BLACKLISTED' && cv.validateBlacklistedURL(value, context, false) === false) {
				vr.set(false, cv.getConstraintMessage());
			} else if (cv.constraintType === 'URL_BLACKLISTED' && cv.validateBlacklistedURL(value, context, true) === false) {
				vr.set(false, cv.getConstraintMessage());
			}

			// Finally, if all is good
			return vr;
		},

		/**
		 * Validates a date in the format of d.m.yyyy or dd.mm.yyyy. The second parameter is optional. If true, the given date
		 * must be in the future starting with the current date. If it is false, it must be in the past starting the with the current date.
		 *
		 * @method validateDate
		 * @param inputDate
		 * @returns {boolean}
		 */
		validateDate: function (date, constraint) {

			// delegate to parse function if not a date object already
			if (Object.prototype.toString.call(date) !== '[object Date]') {
				date = SCS.utils.date.parseDateDay(date);
			}
			// assert for valid object
			if (!date) {
				return false;
			}

			// get validation constraints
			var config = this.constraintData;

			// support old options for compatibility reasons (used by validate)
			if (constraint === true && date < new Date()) {
				return false; // DATE_IN_FUTURE
			}
			if (constraint === false && date > new Date()) {
				return false; // DATE_IN_PAST
			}

			// Get the time from the referenced field.
			// On validation we only get passed the value
			// of the main field. With date we potentially
			// have two input elements (date & time).
			var time = 0;
			if (config.refTimeField) {
				if(config.refTimeField.value) {
					time = config.refTimeField.value;
				} else if(typeof config.refTimeField.val === 'function') {
					time = config.refTimeField.val();
				}
			}

			// put time on date object (supports optional hour format)
			if (time) {
				time = SCS.utils.date.toHours(time);
				date.setMinutes(time * 60);
			}

			// dispatch the actual check to the library function
			return SCS.utils.date.isValidDate(date, this.constraintData);

		},
		// EO validateDate

		/**
		 * Validates a date in the format of d.m.yyyy or dd.mm.yyyy. The second parameter is optional. If true, the given date
		 * must be in the future starting with the current date. If it is false, it must be in the past starting the with the current date.
		 *
		 * @method validateDate
		 * @param inputDate
		 * @returns {boolean}
		 */
		validateDay: function (date) {

			// delegate to parse function if not a date object already
			if (Object.prototype.toString.call(date) !== '[object Date]') {
				date = SCS.utils.date.parseDateDay(date, this.constraintData);
			}
			// assert for valid object
			if (!date) {
				return false;
			}

			// day is valid if it is a work day (by business hours)
			return SCS.utils.date.isValidDay(date, this.constraintData);

		},
		// EO validateDate

		validateByForeignField: function (value) {
			var field = this.constraintData.foreignFieldName;
			if (field) {
				var selector = 'select[name="' + field + '"],input:checked[type=radio][name="' + field + '"],input:checked[type=checkbox][name="' + field + '"],input[type=text][name="' + field + '"]';
				var foreignFieldValue = $(selector).val();
				for (var key in this.foreignValidationModels) {
					if (this.foreignValidationModels.hasOwnProperty(key)) {
						if (key === foreignFieldValue) {
							var cv = new ClientValidation(this.foreignValidationModels[key]);
							return cv.validate(value);
						}
					}
				}
			}
			this.constraintType = 'NONE';
			return this.validate(value);
		},

		// FIXME: Real asynchronous validation would be a cool feature
		// but rewriting all consumers of this API is too much work compared to the benefits.
		// This just returns false (marks the field invalid), resets the validation markup afterwards,
		// does the validation asynchronously and caches the result and then re-triggers the validation,
		// for which it can return the cached result.
		// If the validation was triggered as part of a submit, this will submit the form when
		// the validation call has completed.
		validateAsynchronously: function validateAsynchronously(key, validator, context) {
			var cv = this;
			// Init cache of asynchronous validation results
			if (!validateAsynchronously.cache) {
				validateAsynchronously.cache = {};
			}
			if (!cv.formAPI) {
				throw new Error('Asynchronous validation hack/workaround is only available for full forms.');
			}
			// Result already available or validation currently running.
			if (key in validateAsynchronously.cache) {
				return validateAsynchronously.cache[key] === undefined ? false : validateAsynchronously.cache[key];
			}
			// Mark validation as running.
			validateAsynchronously.cache[key] = undefined;
			// Disable scrolling temporarily
			cv.formAPI.setEnableValidationScrolling(false);

			validator(function (result, error) {
				if (error) {
					// The validation could not be performed at this time. Abort.
					if (error.status && error.responseText) {
						try {
							error = $.parseJSON(error.responseText);
							cv.formAPI.renderPopupMessage(error.message);
						}
						catch (e) {
							cv.formAPI.renderPopupMessage(error.responseText);
						}
					} else {
						cv.formAPI.renderPopupMessage('Unspecified Error');
					}
					delete validateAsynchronously.cache[key];
					return;
				}
				validateAsynchronously.cache[key] = !!result;
				cv.formAPI.setEnableValidationScrolling(true);
				// Re-trigger form validation
				if (context === 'submit') {
					cv.formAPI.submit();
				} else if (context === 'advanceStep') {
					cv.formAPI.advanceStep();
				} else if (context === 'stepAction') {
					cv.formAPI.stepAction();
				} else if (typeof context === 'function') {
					cv.formAPI.onFormValidate(context);
				} else {
					cv.formAPI.validateForm();
				}
			});

			window.setTimeout(function () {
				// Check if validation is still running.
				// If so, reset the fields so they don’t appear invalid while the validation is running
				if (validateAsynchronously.cache[key] === undefined && key in validateAsynchronously.cache) {
					cv.formAPI.resetValidation();
				}
			}, 0);

			// Mark as invalid until validation has finished (if validation was synchronous, this already contains the correct result).
			return validateAsynchronously.cache[key] === undefined ? false : validateAsynchronously.cache[key];
		},

		validateUrlExists: function (value, options, context) {
			if (/[^a-zA-Z0-9_\-öäüÖÄÜ]/.test(value)) {
				// PORTAL-5702: No special characters except - and _ are allowed.
				return false;
			}

			var url = options.urlPattern.replace(/\*/g, value);

			var urlPatternCheckIsNegative = options.urlPatternCheckIsNegative === 'true';
			var key = 'validateUrlExists-' + (urlPatternCheckIsNegative ? 'negative' : 'positive') + '-' + url;
			var validator;
			// Use the JS route if .js appears in the URL.
			// Might be in a selector, as the extension
			// or even as a param (so we can force URLs to be recognized as JS)
			if (url.indexOf('.js') > -1) {
				var global = /[&?]global=([^&]+)(&|$)/.exec(url);
				if (global && (global = global[1])) {
					// Safeguard against accidental overrides by not allowing globals that already exist
					if (window[global]) {
						global = null;
					}
				}
				validator = function jsValidator(cb) {
					$.ajax(url, {
						complete: function (xhr, error) {
							// A timeout is the only way to detect whether there was valid javascript at the given location
							var isValid = error === 'success';
							// We can also check for a global that was created by the script
							if (global && isValid) {
								isValid = !!window[global];
								window[global] = undefined;
							}
							cb(urlPatternCheckIsNegative ? !isValid : isValid);
						},
						dataType: 'script',
						timeout: 2000
					});
				};
			} else {
				validator = function xhrValidator(cb) {
					$.ajax(url, {
						complete: function (xhr) {
							var isValid = xhr.status >= 200 && xhr.status < 400;
							cb(urlPatternCheckIsNegative ? !isValid : isValid);
						},
						dataType: 'text'
					});
				};
			}
			return this.validateAsynchronously(key, validator, context);
		},

		/**
		 * Use the Luhn algorithm to validate that a sim card number is valid.
		 * @param value
		 */
		validateSimCardNumber: function validateSimCardNumber(value) {

			//Valid sim numbers have 20 digits (only new ones are considered).
			if (!value || !/^\d{20}/.test(value)) {
				return false;
			}

			/**
			 * Luhn algorithm in JavaScript: validate credit card number supplied as string of numbers
			 * @author ShirtlessKirk. Copyright (c) 2012.
			 * @license WTFPL (http://www.wtfpl.net/txt/copying)
			 */
			var luhnChk = (function (arr) {
				return function (ccNum) {
					var
						len = ccNum.length,
						bit = 1,
						sum = 0,
						val;

					while (len) {
						len -= 1;
						val = parseInt(ccNum.charAt(len), 10);
						/* jshint bitwise: false */
						sum += (bit ^= 1) ? arr[val] : val;
					}

					return sum && sum % 10 === 0;
				};
			}([0, 2, 4, 6, 8, 1, 3, 5, 7, 9]));

			return luhnChk(value);
		},

		/**
		 * use ajax to validate field
		 * @param value
		 */
		validateByAjax: function validateByAjax(value, constraintData, context) {
			var ajaxUrl = constraintData.ajaxUrl,
				formFieldName = constraintData.formFieldName,
				key = 'validateByAjax-' + formFieldName + '-' + value,
				data = $.extend({
					value: value,
					formId: this.$form.find('*[name=\':formid\']').val(),
					formPath: this.$form.find('*[name=\':formstart\']').val()
				}, constraintData),
				validator = function ajaxValidator(callback) {
					$.ajax({
						url: ajaxUrl,
						type: 'POST',
						cache: false,
						data: data,
						dataType: 'json',
						success: function (data) {
							var isValid = data.isValid;
							callback(isValid);
						},
						error: function (jqXHR) {
							callback(null, jqXHR);
						}
					});
				};

			return this.validateAsynchronously(key, validator, context);
		},

		validateIBAN: function (value, context) {
			var res = /^[A-Z]{2}[0-9]{2}([0-9]{5})[0-9A-Z]{12}$/.exec(value);
			var bcNumber = res && res[1];
			if(!bcNumber) {
				return false;
			}
			var sanitizedValue = bcNumber.replace(/^0*/, '');
			if(sanitizedValue.length < 3) {
				return false;
			}
			var validator = ibanFieldValidator(sanitizedValue);
			var key = 'validateIBAN-' + sanitizedValue;

			return this.validateAsynchronously(key, validator, context);
		},

		validateBlacklistedURL: function (value, context, inverted) {
			var validator = urlBlacklistValidation(value, inverted);
			var key1 = 'validateIURLBlacklisted-' + encodeURIComponent(value);
			var key2 = 'validateIURLNotBlacklisted-' + encodeURIComponent(value);
			var key = inverted ? key1 : key2;

			return this.validateAsynchronously(key, validator, context);
		}

	};

	w.ScForm = w.ScForm || {};
	w.ScForm.createClientValidation = function (clientValidationJson, $form) {
		return new ClientValidation(clientValidationJson, $form);
	};

}(window, window.$, window.SCS = window.SCS || {}));



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/forms/clientlibs/shared/js/libraries/ScForm.ClientValidation.js
// module id = 264
// module chunks = 0